import React from 'react';
import { menuItems } from '../menu/menuItems.js';
import MenuCardContainer from './MenuCardContainer.js';



function MenuPreview() {
    // console.log(menuItems);

    return (
        <div style={styles.container}>
            <div>
                <h1 style={styles.title}>Explore the garden.</h1>
            </div>
            <div style={styles.menuItemsContainer}>
            {menuItems.snacks.map((items, index) => <MenuCardContainer items={items} key={index} /> )}
            </div>

            <a href='/Menu'><button style={styles.menuBtn}>See Menu</button></a>


        </div>
    );
};

export default MenuPreview;


const styles = {
    container: {
        width: '100%',
        paddingBottom: '5%'
    },
    title: {
        paddingLeft: '10%',
    },
    menuItemsContainer: {
        width: '85%',
        display: 'flex',
        flexWrap: 'wrap',
        flexDirection: 'space-between',
        margin: 'auto',
    },
    menuBtn: {
        fontFamily: 'sans serif',
        color: 'white',
        backgroundColor: '#191E20',
        border: "none",
        paddingTop: '1.5%',
        paddingBottom: '1.5%',
        paddingLeft: '5%',
        paddingRight: '5%',
        marginTop: '2%',
        marginLeft: '6%',
    }
}